import React from 'react';
import Weather from "./Weather";

import './App.css';

export default function App(){
  return (
    <div className="App">
      <div className="container">
        
        <Weather defaultCity="Las Vegas" />

      <footer>
        coded by kaila turpin        
        
        <a href="https://github.com/awolkailer/wa-react">  open sourced on GitHub
        </a>
        </footer>
       
       </div>
    </div>
  );
}


